import { createRootRouteWithContext } from '@tanstack/react-router';
import { TanStackRouterDevtools } from '@tanstack/react-router-devtools';
import type { QueryClient } from '@tanstack/react-query';
import { NotFoundPage } from '@/pages/not-found';
import { AuthLayout } from '@/layouts/AuthLayout';
import { NoticeProvider } from '@/components/NoticeBanner';

export interface MyRouterContext {
  queryClient: QueryClient;
}

export const Route = createRootRouteWithContext<MyRouterContext>()({
  component: () => (
    <NoticeProvider>
      <AuthLayout />
      <TanStackRouterDevtools />
    </NoticeProvider>
  ),
  notFoundComponent: NotFoundPage,
});
